import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTheme } from '@material-ui/core/styles';
import { propTypes } from 'Classes/Plan';
import { Route, Switch } from 'Components/UI/FacetRouter/FacetRouter';
import { advisorPlanPath } from 'Consts/Strings';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import Home from './Home';
import External from './ExternalPlan';

import './index.css';

function getCore(type) {
  switch (type) {
    case 'external':
      return External;
    default:
      return Home;
  }
}

function Plans({ plan, theme }) {
  const core = getCore(plan.type);
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Plans',
    isPageView: true,
  });

  useBackgroundColor(theme.palette.facet.lightGray);

  return (
    <div
      className="Plans padding-2"
      {...rootNodeProps}
    >
      <Switch>
        <Route exact path={advisorPlanPath} component={Home} />
        <Route component={core} />
      </Switch>
    </div>
  );
}

const mapStateToProps = ({ plan }) => ({
  plan: {
    ...plan,
    id: Number(plan.id),
    householdID: Number(plan.householdID),
  },
});

Plans.propTypes = {
  plan: propTypes.isRequired,
  theme: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(withRouter(withTheme(Plans)));
